<div class="dialog_overlay visible ready {{className}}" *ngIf="isDialogVisible == true">
    <div class="dialogMsg">{{message}}</div>
    <button matButton="outlined" (click)="cancelClicked()" class="dialog_btn">Cancel</button>
    <button matButton="outlined" (click)="okClicked()" class="dialog_btn ml-1">Continue</button>
</div>
